import * as THREE from "three";
import Experience from "../Experience.js";

export default class Keyboard {
  constructor() {
    this.experience = new Experience();
    this.scene = this.experience.scene;
    this.resources = this.experience.resources;
    this.time = this.experience.time;
    this.debug = this.experience.debug;

    // Debug
    if (this.debug.active) {
      this.debugFolder = this.debug.ui.addFolder("Keyboard");
    }

    // Resource
    this.resource = this.resources.items.keyboardModel;

    this.setModel();
  }

  setModel() {
    this.model = this.resource.scene;
    this.model.position.set(0.35, -0.35, 0.5);
    this.model.rotateY(0.1);
    this.model.name = "keyboard";

    this.scene.add(this.model);

    this.model.traverse((child) => {
      if (child instanceof THREE.Mesh) {
        child.castShadow = true;
        child.name = this.model.name;
      }
    });
  }

  setAnimation() {}

  update() {}
}
